module.exports = __webpack_public_path__ + "static/media/win.7740f435.wav";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/sounds/win.wav
// module id = 58
// module chunks = 0